<dx-popup
  [visible]="isVisible"
  [showTitle]="false"
  [width]="440"
  [height]="'auto'"
  (onHiding)="closeModal()"
>
  <div *dxTemplate="let data of 'content'" class="modal-container">
    <div class="modal-header">
      <h4>{{ modalTitle }}</h4>
      <button class="close-btn" (click)="closeModal()">&times;</button>
    </div>

    <div class="modal-body">
      <!-- Date Field -->
      <div class="form-group">
        <label>Date</label>
        <input
          type="text"
          [value]="formattedDate"
          readonly
          class="form-control readonly-input"
        />
      </div>

      <!-- STATUS 1: Currently a Working Day (override active) -->
      <ng-container *ngIf="selectedDay?.isWorkingDayOverride">
        <!-- Previous Reason on Record -->
        <div class="form-group">
          <label>Reason on record</label>
          <input
            type="text"
            [value]="selectedDay?.holidayReason || ''"
            readonly
            class="form-control readonly-input"
          />
        </div>

        <!-- OVERLAP: weekend + one/more holidays canceled together -> single checkbox -->
        <div class="toggle-card" *ngIf="revertMode === 'OVERLAP'">
          <div>
            <strong class="toggle-title">Revert to Holiday</strong>
            <p class="toggle-sub">
              This date has a weekend and one or more holidays. Reverting will
              restore all of them.
            </p>
          </div>
          <dx-switch [(value)]="revertOverlap"></dx-switch>
        </div>

        <!-- HOLIDAY_ONLY: one or more holiday rows were canceled -->
        <div class="toggle-card" *ngIf="revertMode === 'HOLIDAY_ONLY'">
          <div>
            <strong class="toggle-title">Revert to Holiday</strong>
            <p class="toggle-sub">
              Removes the working-day override for all holidays configured on
              this date.
            </p>
          </div>
          <dx-switch [(value)]="revertToHoliday"></dx-switch>
        </div>

        <!-- WEEKEND_ONLY: only the weekend row was canceled -->
        <div class="toggle-card" *ngIf="revertMode === 'WEEKEND_ONLY'">
          <div>
            <strong class="toggle-title">Revert to Weekend</strong>
            <p class="toggle-sub">
              This date returns to default weekend holiday.
            </p>
          </div>
          <dx-switch [(value)]="revertToWeekend"></dx-switch>
        </div>
      </ng-container>

      <!-- STATUS 2: Normal (weekend / holiday, no override) -->
      <ng-container *ngIf="!selectedDay?.isWorkingDayOverride">
        <div class="info-status-box">
          <p *ngIf="selectedDay?.isHoliday">
            This date is configured as
            <strong>{{ holidayNamesLabel }}</strong
            >.
          </p>
          <p *ngIf="selectedDay?.isWeekend && !selectedDay?.isHoliday">
            This date is a default <strong>{{ dayName }}</strong> holiday, as
            per the weekend configuration.
          </p>
        </div>

        <div class="toggle-card">
          <div>
            <strong class="toggle-title">Mark as Working Day</strong>
            <p class="toggle-sub">Requires a reason.</p>
          </div>
          <dx-switch [(value)]="markAsWorkingDay"></dx-switch>
        </div>

        <div class="form-group" *ngIf="markAsWorkingDay">
          <label>
            Reason for marking as Working Day
            <span class="required">*</span>
          </label>
          <input
            type="text"
            [(ngModel)]="reasonInput"
            placeholder="e.g., Compensatory working day announced by management"
            class="form-control"
          />
        </div>
      </ng-container>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <dx-button
        text="Cancel"
        class="themeButtonWhite"
        [disabled]="isSaving"
        (click)="closeModal()"
      ></dx-button>
      <dx-button
        [text]="isSaving ? 'Updating...' : 'Update'"
        class="themeButton"
        [disabled]="isSaving"
        (onClick)="onSave()"
      ></dx-button>
    </div>
  </div>
</dx-popup>
